import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from '../Icon/Icon';
const SharedByContactBadge = ({ contact }) => {
    return (_jsxs("div", { title: "Shared by contact", className: "flex items-center rounded bg-info px-1.5 py-1 text-neutral-contrast", children: [_jsx(Icon, { ariaLabel: "Shared by contact", type: "archive", className: "mr-1 text-info-contrast", size: "medium" }), _jsx("div", { className: "text-center text-sm font-semibold lg:text-xs", children: contact.name })] }));
};
export default SharedByContactBadge;
